import React from 'react'
import {
    Button,
    Dialog,
    DialogContent,
    DialogActions,
    TextField,
    IconButton,
    Paper,
    DialogTitle
} from '@mui/material/';

const ModalSistema = (props) => {

    const {
        abrirModal,
        handleClose,
        funcion,
        mensaje,
        titulo,
    } = props;

    return (
        <div>
            <Dialog
                open={abrirModal}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                maxWidth="sm"
                fullWidth
            >   
                <DialogTitle>
                    {titulo}
                </DialogTitle>
                <DialogContent>
                    {mensaje}
                </DialogContent>

                <DialogActions>
                    <Button
                        onClickCapture={funcion}
                    >
                        Aceptar
                    </Button>
                    <Button onClick={handleClose}>
                        Cancelar
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    )
}

export default ModalSistema